import {lazy} from 'react';

export const AuthContainerModalAsync = lazy(() => import('./AuthContainerModal'));
